import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { ReactSVG } from 'react-svg';

import {theme} from '../../../themes/default-theme';
import Slider from '../Slider';
import RespImg from '../../ui/RespImg';
import {Icon} from '../../ui';
import chevronLeft from '../../../assets/icons/chevron-right-grey.svg';
import chevronRight from '../../../assets/icons/chevron-right-grey.svg';

const Container = styled.div`
  position: relative;
  padding-left: 50px;
  padding-right: 50px;

  ${theme.breakpoints.down("sm")} {
    padding: 0 20px;
  }
    .slick-dots {
      list-style: none;
      text-align: center;
      font-size: 0;
      text-align: center;
      padding: 0;

      li {
          display: inline-block;
          padding: 0 6px;

          &.slick-active {
              button {
                  background-color: ${theme.palette.vividBlue};
              }
          }
      }

      button {
          cursor: pointer;
          width: 12px;
          height: 12px;
          border-radius: 12px;
          border: none;
          background-color: ${theme.palette.middleGrey};
          font-size: 0;
      }
  }

  .slick-next,
  .slick-prev {
    position: absolute;
    top: calc(50% - 22px);
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1;

    ${theme.breakpoints.down("sm")} {
      display: none;
      opacity: 0;
    }
  }

  .slick-prev {
    transform: translateX(-20px);
    left: -28px;
    right: auto;
  }

  .slick-next {
    transform: translateX(20px);
    left: auto;
    right: -28px;
  }

`


const PrevArrow = ({currentSlide, slideCount, children, ...props}) => {
  return (
    <Icon infoGrey {...props}>
      <ReactSVG src={chevronLeft} />
    </Icon>
  )
}

const NextArrow = ({currentSlide, slideCount, children, ...props}) => {
  return (
    <Icon infoGrey {...props}>
      <ReactSVG src={chevronRight} />
    </Icon>
  )
}

const ModelCarousel = ({
    items,
    settings,
    theme
  }) => {
  const arrowProps={
    grey: false,
    lightGrey: true,
    medium: true
  }
  const slickSettings = {
    fade: false,
    dots: true,
    // prevArrow: <PrevArrow {...arrowProps}/>,
    // nextArrow: <NextArrow  {...arrowProps}/>,
    ...settings
  }

  console.log('items!', items);
  
  return (
    <Container>
      {(items && items.length > 0) ?
        <Slider
          settings={slickSettings}
          arrowProps={{
            grey: false,
            lightGrey: theme === 'dark' ? false : true,
            darkGrey: theme === 'dark' ? true : false,
            medium: true
          }}
        >
          {items.map((item, index) => (
            <div key={item.id || index}>
              <RespImg
                {...item.image}
                type="png"
              />
            </div>
          ))}
        </Slider>
      : null}
    </Container>
  )
}

ModelCarousel.propTypes = {
  items: propTypes.array.isRequired,
  settings: propTypes.object,
  theme: propTypes.string
}

ModelCarousel.defaultProps = {
  settings: {},
  items: [],
  theme: 'light'
}
  
export default ModelCarousel